export default __webpack_public_path__ + "images/Shipnexa_logo.svg";